export enum LocalStorageKeys {
  CLIENT_VERSION = "CLIENT_VERSION",
  ACTIVE_TREE_ITEM_KEY = "ACTIVE_TREE_ITEM",
  TREE_STATE_KEY = "TREE_STATE",
  ACTIVE_FOLDER_KEY = "ACTIVE_FOLDER",
  FOLDER_TREE_STATE = "FOLDER_TREE_STATE",
  FILTERS_ITEMS_KEY = "FILTERS_ITEMS",
  FOLDERS_ITEMS_KEY = "FOLDERS_ITEMS",
  SELECTED_TAB_KEY = "SELECTED_TAB",
  LAST_URL_KEY = "LAST_URL",
  FAVORITE_KEY = "FAVORITES",
  FAVORITE_TREE_COLLAPSE_STATE_KEY = "FAVORITE_TREE_COLLAPSE_STATE",
  FILTERS_TREE_COLLAPSE_STATE_KEY = "FILTERS_TREE_COLLAPSE_STATE",
}
